import { createUserManager } from 'redux-oidc';

const AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
const SABRE_AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
const SYNXIS_AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
const MYMA_AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
const redirect_uri = process.env.REACT_APP_CALLBACK_URL;
const SABRE_Redirect_Uri = process.env.REACT_APP_SABRE_CALLBACK_URL;
const SYNXIS_Redirect_Url = process.env.REACT_APP_SYNXIS_CALLBACK_URL;
const MYMA_Redirect_url = process.env.REACT_APP_MYMA_CALLBACK_URL;
// console.log("NODE_ENV");
// console.log(process.env.NODE_ENV);
// console.log("REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID");
// console.log(process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID);
let authority_server = AUTHORITY_SERVER;

localStorage.setItem('host_name_url', window.location.hostname);
console.log(window.location.hostname);
function checkServer(url) {
  if (
    window.location.hostname.toLowerCase().startsWith('app.sabre.bookmebob.com')
  )
    return SABRE_AUTHORITY_SERVER;
  else if (
    window.location.hostname
      .toLowerCase()
      .startsWith('app.concierge.synxis.com')
  )
    return SYNXIS_AUTHORITY_SERVER;
  else if (
    window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
  )
    return AUTHORITY_SERVER;
  else if (
    window.location.hostname
      .toLowerCase()
      .startsWith('app.devtest.bookmebob.com')
  )
    return AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().startsWith('app.myma.ai'))
    return MYMA_AUTHORITY_SERVER;
  //else return AUTHORITY_SERVER;
}

function callBackurl(url) {
  if (
    window.location.hostname.toLowerCase().startsWith('app.sabre.bookmebob.com')
  )
    return SABRE_Redirect_Uri;
  else if (
    window.location.hostname
      .toLowerCase()
      .startsWith('app.concierge.synxis.com')
  )
    return SYNXIS_Redirect_Url;
  else if (
    window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
  )
    return redirect_uri;
  else if (
    window.location.hostname
      .toLowerCase()
      .startsWith('app.devtest.bookmebob.com')
  )
    return redirect_uri;
  else if (window.location.hostname.toLowerCase().startsWith('app.myma.ai'))
    return MYMA_Redirect_url;
  //else return redirect_uri;
}

checkServer();

const client_id = process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID;
const userManagerConfig = {
  client_id,
  redirect_uri: callBackurl(window.location.hostname),
  response_type: 'id_token token',
  //post_logout_redirect_uri: "http://localhost:3000",
  scope: 'openid profile api1',
  authority: checkServer(window.location.hostname),
  // silent_redirect_uri: 'http://localhost:5100/silentRenew.html',
  // automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  // monitorSession: true
};

const userManager = createUserManager(userManagerConfig);
console.log(userManager);
export default userManager;
